import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    id: 'modal-confirm',
    "z-index": "99999999",
    closeOnExternalClick: false
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.config?.title || 'Confirm'), 1)
    ]),
    content: _withCtx(() => [
      _createVNode(_component_v_row, { class: "ma-3" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.config?.text || 'Are you sure you want to do this action?'), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_v_row, { class: "justify-end ma-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_CustomButton, {
            level: _ctx.$enums.ButtonLevels.Secondary,
            class: "mr-3",
            onClick: _ctx.onCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.config?.cancelButtonText || 'Cancel'), 1)
            ]),
            _: 1
          }, 8, ["level", "onClick"]),
          _createVNode(_component_CustomButton, {
            level: _ctx.$enums.ButtonLevels.Primary,
            onClick: _ctx.onConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.config?.confirmButtonText || 'Confirm'), 1)
            ]),
            _: 1
          }, 8, ["level", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}